import { render, staticRenderFns } from "./HiddenAttributeButton.vue?vue&type=template&id=8583b79a"
import script from "./HiddenAttributeButton.vue?vue&type=script&lang=js"
export * from "./HiddenAttributeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports